import { App, createVNode, h, Plugin, render } from 'vue';

import Dialogs from '../components/Dialogs/Dialogs.vue';

export interface DialogsPluginOptions {
  mountNodeClass?: string;
  mountNodeId?: string;
}

export const DEFAULT_DIALOGS_PLUGIN_NODE_ID = 'stash-dialogs-mount-node';

export default <Plugin>{
  install(app: App, options?: DialogsPluginOptions) {
    const mountNodeId = options?.mountNodeId || DEFAULT_DIALOGS_PLUGIN_NODE_ID;
    let mountNode = document.getElementById(mountNodeId);

    if (!mountNode) {
      mountNode = document.createElement('div');
      mountNode.id = mountNodeId;
      mountNode.dataset.test = DEFAULT_DIALOGS_PLUGIN_NODE_ID;
      document.body.appendChild(mountNode);
    }

    if (options?.mountNodeClass && !mountNode.classList.contains(options.mountNodeClass)) {
      mountNode.classList.add(options.mountNodeClass);
    }

    const vNode = createVNode(h(Dialogs));
    vNode.appContext = app._context;

    render(vNode, mountNode);
  },
};
